/* eslint-disable */
import { notification } from 'antd';
import { fabric } from 'fabric';
import { cloneDeep, isEmpty } from 'lodash';
import { CUSTOM_TEXT, generateId, getTextSize, RECT, TEXTBOX, ungroup } from '../../utils';

export const SCALE_SIZE = 1;
export const AUTO = 'auto';
export const FIXED = 'fixed';
export const EPS = 1;

fabric.CustomText = fabric.util.createClass(fabric.Group, {
  initialize(objects, options) {
    this.callSuper('initialize', objects, options, true);
    this.set(
      'textMode',
      options.textMode || {
        width: AUTO,
        height: AUTO,
      },
    );
    this.on('scaling', this.onScaling);
  },
  onScaling: function (e) {
    const width = this.scaleX * this.width;
    const height = this.scaleY * this.height;
    const getTextMode = () => {
      let mode = this.textMode.height;
      if (!e || isEmpty(e)) mode = FIXED;
      else {
        const { transform } = e;
        if ((transform.corner === 'ml' || transform.corner === 'mr') && mode === AUTO) mode = AUTO;
        else mode = FIXED;
      }
      return {
        width: AUTO,
        height: mode,
      };
    };
    this.set({
      width,
      height,
      scaleX: 1,
      scaleY: 1,
      flipX: false,
      flipY: false,
      textMode: getTextMode(),
    });
    const textObj = this.getTextObj();
    if (textObj.isLabelComponent) {
      textObj.set({
        maxWidth: width,
      });
    }
    this.updateRectObj();
    this.setCoords();
  },
  getRectObj: function () {
    return this._objects.find((obj) => obj.type === RECT);
  },
  getTextObj: function () {
    return this._objects.find((obj) => obj.type === TEXTBOX);
  },
  updateContainer: function () {
    this.updateRectObj();
    this.set({
      fill: 'transparent',
      stroke: 'transparent',
      noScaleCache: false,
    });
  },
  updateLabelComponent: function (width) {
    const textObj = this.getTextObj();
    if (!textObj.isLabelComponent) return;
    const longestWidth = Math.max(width, this.width);
    textObj.set({ width: longestWidth });
    this.set({ width: longestWidth });
  },
  updateTextObj: function () {
    const rectObj = this.getRectObj();
    const textObj = this.getTextObj();
    textObj.set({
      width: textObj.isLabelComponent ? textObj.width : this.width,
      left: -this.width / 2,
      parentId: rectObj.id,
      isTextComponent: true,
    });
    switch (this.textAlignVertical) {
      case 'top':
        textObj.set({ top: -this.height / 2, originY: 'top' });
        break;
      case 'middle':
        textObj.set({ top: 0, originY: 'center' });
        break;
      case 'bottom':
        textObj.set({ top: this.height / 2, originY: 'bottom' });
        break;
    }
  },
  updateRectObj: function () {
    const rectObj = this.getRectObj();
    rectObj.set({
      width: this.width + EPS,
      height: this.height + EPS,
      top: -this.height / 2 - EPS,
      left: -this.width / 2 - EPS,
      scaleX: 1,
      scaleY: 1,
      id: rectObj.id || generateId(),
    });
  },
  drawCustomText: function (obj, stackOrder) {
    const textObj = obj.getTextObj();
    const rectObj = obj.getRectObj();
    window.canvas.remove(rectObj, textObj);
    textObj.set({ objectCaching: false, angle: 0, scaleX: 1, scaleY: 1 });
    rectObj.set({
      objectCaching: false,
      angle: 0,
      stroke: 'transparent',
      strokeWidth: 0,
      visible: false,
      originX: 'left',
      originY: 'top',
    });
    const newObj = new fabric.CustomText([rectObj, textObj], obj);
    window.canvas.insertAt(newObj, stackOrder);
    window.canvas.setActiveObject(newObj);
    window.canvas.renderAll();
  },
  updateClipPath: function () {
    const clipPathObj = new fabric.Rect(this.clipPath);
    this.clipPath = clipPathObj;
  },
  toObject(propertiesToInclude) {
    this.updateClipPath();
    const obj = this.callSuper(
      'toObject',
      ['objectCaching', 'id', 'name', 'textAlignVertical', 'isCustomText', 'textMode'].concat(propertiesToInclude),
    );
    return obj;
  },
  toSVG() {
    this.updateClipPath();
    return this.callSuper('toSVG');
  },
  render(ctx) {
    const textObj = this.getTextObj();
    let textHeight = textObj.height;
    if (textObj.isLabelComponent) {
      const { textHeight: height } = getTextSize(textObj.text, JSON.parse(JSON.stringify(textObj)));
      textHeight = height;
      this.width = textObj.maxWidth || this.width;
    }
    if (this.textMode.height === AUTO) this.height = textHeight;
    this.updateTextObj();
    this.updateContainer();
    this.set({ clipPath: this.getRectObj().set({ visible: true }), dirty: true });
    this.setCoords();
    if (!this.name) {
      const name = textObj.isLabelComponent ? 'Label' : 'Text';
      this.name = name;
      textObj.name = name;
    }
    this.setControlsVisibility({ ExpandHeightControl: textHeight > this.height });
    this.callSuper('render', ctx);
  },
  updateTextAlign() {
    this.updateTextObj();
    const items = ungroup(cloneDeep(this), canvas, true);
    items.forEach((i) => window.canvas.remove(i));
    return { top: items[1].top, left: items[1].left };
  },
  drawBoundingHiddenRect() {
    const rectObj = this.getRectObj();
    rectObj.set({
      visible: true,
      strokeWidth: 1,
      stroke: this.textMode.height === AUTO ? '#096dd9' : '#ec1c24',
    });
  },
});

fabric.CustomText.fromObject = function (object, callback) {
  fabric.util.enlivenObjects(object.objects, function (enlivenedObjects) {
    const options = fabric.util.object.clone(object, true);
    delete options.objects;
    return callback(new fabric.CustomText(enlivenedObjects, options, true));
  });
};

const expandIcon = document.createElement('img');
expandIcon.src =
  'data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KDTwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIFRyYW5zZm9ybWVkIGJ5OiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiMwODZlZDkiPgoNPGcgaWQ9IlNWR1JlcG9fYmdDYXJyaWVyIiBzdHJva2Utd2lkdGg9IjAiLz4KDTxnIGlkPSJTVkdSZXBvX3RyYWNlckNhcnJpZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgoNPGcgaWQ9IlNWR1JlcG9faWNvbkNhcnJpZXIiPiA8cGF0aCBkPSJNNiA5TDQyIDkiIHN0cm9rZT0iIzA4NmVkOSIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4gPHBhdGggZD0iTTYgMTlMNDIgMTkiIHN0cm9rZT0iIzA4NmVkOSIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4gPHBhdGggZD0iTTYgMjZMMjQgNDBMNDIgMjYiIHN0cm9rZT0iIzA4NmVkOSIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4gPC9nPgoNPC9zdmc+';

function renderIcon(ctx, left, top, styleOverride, fabricObject) {
  fabricObject.setControlsVisibility({ ExpandHeightControl: fabricObject.type === CUSTOM_TEXT });
  const size = this.cornerSize;
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(expandIcon, -size / 2, -size / 2, size, size);
  ctx.restore();
}

fabric.CustomText.prototype.controls.ExpandHeightControl = new fabric.Control({
  x: 0,
  y: 0.5,
  offsetY: 15,
  cursorStyle: 'pointer',
  render: renderIcon,
  mouseDownHandler: function (eventData, transform) {
    const { target } = transform;
    target.set({ textMode: { ...target.textMode, height: AUTO } });
  },
  cornerSize: 12,
  visible: false,
});

export function createCustomObj() {
  const hiddenRect = new fabric.Rect({
    width: 100,
    height: 100,
    fill: 'transparent',
    stroke: 'transparent',
    objectCaching: false,
    selectable: false,
    visible: false,
  });

  const textObj = new fabric.Textbox('Label', {
    name: 'Label',
    splitByGrapheme: false,
    textAlign: 'center',
    originX: 'left',
    isCustomText: true,
    isLabelComponent: true,
  });

  const obj = new fabric.CustomText([hiddenRect, textObj], {
    id: generateId(),
    name: 'Label',
    type: CUSTOM_TEXT,
    textAlignVertical: 'top',
    isCustomText: true,
    top: 0,
    left: 0,
    width: 100,
    height: 100,
    objectCaching: false,
  });
  return obj;
}

export function createCustomText(text, isLabelComponent = false) {
  const MAX_CHARACTERS = 2000;
  if (text.length > MAX_CHARACTERS) {
    notification.error({
      message: 'Please ensure that no words exceed 2,000 characters when pasting and try again.',
    });
    return;
  }

  const hiddenRect = new fabric.Rect({
    fill: 'transparent',
    stroke: 'transparent',
    objectCaching: false,
    selectable: false,
    visible: false,
  });

  const { textWidth, textHeight } = getTextSize(text, DEFAULT_TEXT_STYLE);

  const textObj = new fabric.Textbox(text, {
    ...DEFAULT_TEXT_STYLE,
    name: 'Text',
    originX: 'left',
    isCustomText: true,
    isLabelComponent,
    width: textWidth,
    height: textHeight,
    fontSize: 12,
  });

  const obj = new fabric.CustomText([hiddenRect, textObj], {
    id: generateId(),
    name: 'Text',
    type: CUSTOM_TEXT,
    textAlignVertical: 'top',
    isCustomText: true,
    objectCaching: false,
    fill: 'transparent',
    stroke: 'transparent',
    width: textObj.width,
    height: textObj.height,
  });
  return obj;
}

window.fabric.CustomText = fabric.CustomText;

export default fabric.CustomText;
